import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  bottomPart: {
    height: "24vh",
    width: "100%",
    backgroundColor: "#f2f2f3",
    position: "static",
    bottom: "0",
  },
  leftPart: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: `calc(80vh - 64px)`,
    flexDirection: "column",
  },
  rightPart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: `calc(80vh - 64px)`,
  },
  capital: {
    fontSize: 20,
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 42,
    fontWeight: "bolder",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  content: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    width: 450,
  },
  bottomContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "24vh",
    color: "#000",
    fontWeight: "bolder",
  }
}));